import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { URL } from "../config";
import { CustomTextField } from "./CustomeTextField";
import { CustomDatePicker } from "./CustomDatePicker";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { makeStyles } from "@mui/styles";

export const CustomFormControl = styled(FormControl)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#a8bbcf",
  },
  "& label": {
    color: "#444D56",
  },
  "&.MuiOutlinedInput-root": {
    color: "#ffffff !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: '#444D56',
  },
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .MuiFormHelperText-root": {
    color: "white",
  },
}))

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ color: "#ffffff", m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    "& .MuiPaper-root.MuiDialog-paper": {
      backgroundColor: "#121212",
      minWidth: "450px",
    },
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    color: "#ffffff",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Upload = () => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [form, setForm] = useState({
    videoLink: "",
    thumbnail: "",
    title: "",
    genre: "",
    ageGroup: "",
    releaseDate: dayjs(new Date()),
  });

  const isValidUrl = (url) =>
    /^(http|https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
      url
    );

  const postVideo = () => {
    fetch(URL + "/v1/videos", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        videoLink: form.videoLink,
        thumbnail: form.thumbnail,
        title: form.title,
        genre: form.genre,
        ageGroup: form.ageGroup,
        releaseDate: form.releaseDate.format("DD MMM YYYY"),
      }),
    })
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((error) => console.error(error));
    handleClose();
  };

  function handleFormChange(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  return (
    <div>
      <Button variant="contained" onClick={handleOpen}>
        <FileUploadIcon />
        Upload
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Upload Video
        </BootstrapDialogTitle>
        <DialogContent>
          <Stack spacing={2} padding={2}>
            <CustomTextField
              id="video-link"
              label="Video Link"
              variant="outlined"
              helperText={
                form.videoLink && !isValidUrl(form.videoLink)
                  ? "Invalid video link"
                  : "This link will be used to desire the video"
              }
              name="videoLink"
              value={form.videoLink}
              onChange={(e) => handleFormChange(e)}
            />
            <CustomTextField
              id="outlined-basic"
              label="Thumbnail image link"
              variant="outlined"
              helperText={
                form.thumbnail && !isValidUrl(form.thumbnail)
                  ? "Invalid image link"
                  : "This link will be used to preview the thumbnail image"
              }
              name="thumbnail"
              value={form.thumbnail}
              onChange={(e) => handleFormChange(e)}
            />
            <CustomTextField
              id="title"
              label="Title"
              variant="outlined"
              helperText="This title will be the representative text for video"
              value={form.title}
              name="title"
              onChange={(e) => handleFormChange(e)}
            />
            <CustomFormControl fullWidth>
              <InputLabel
                id="demo-simple-select-label"
                // style={{ color: "#444D56" }}
              >
                Suitable age group for the clip
              </InputLabel>
              <Select
                labelId="Suitable age group for the clip"
                id="Suitable age group for the clip"
                value={form.ageGroup}
                name="ageGroup"
                label="Suitable age group for the clip"
                onChange={(e) => handleFormChange(e)}
                helperText="This will be used to filter videos on age group suitability"
              >
                {['Any', 12, 16, 18].map((val) => <MenuItem value={val}>{val}</MenuItem>)}
              </Select>
              <FormHelperText>This will be used to filter videos on age group suitability</FormHelperText>
            </CustomFormControl>
            <CustomFormControl fullWidth>
              <InputLabel
                id="genre"
              >
                Genre
              </InputLabel>
              <Select
                labelId="genre"
                id="genre"
                value={form.genre}
                name="genre"
                label="genre"
                onChange={(e) => handleFormChange(e)}
              >
                {['All', "Education", "Sports", "Comedy", "Lifestyle"].map((val) => <MenuItem value={val}>{val}</MenuItem>)}
              </Select>
              <FormHelperText>Genre will help in categorizing your video</FormHelperText>
            </CustomFormControl>
            {/* <CustomTextField
              id="genre"
              label="Genre"
              variant="outlined"
              helperText="Genre will help in categorizing your video"
              value={form.genre}
              name="genre"
              onChange={(e) => handleFormChange(e)}
            /> */}
            {/* <CustomTextField
              id="age-group"
              label="Subtitle age group for the clip"
              variant="outlined"
              helperText="This will be used to filter videos on age group suitability"
              name="ageGroup"
              value={form.ageGroup}
              onChange={(e) => handleFormChange(e)}
            /> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <CustomDatePicker
                  label="Release Date"
                  slotProps={{
                    textField: {
                      helperText: "This will be used to sort the videos",
                    },
                  }}
                  name="releaseDate"
                  value={form.releaseDate}
                  onChange={(e) => handleFormChange(e)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={
              !(
                form.videoLink &&
                form.thumbnail &&
                form.title &&
                form.genre &&
                form.ageGroup &&
                form.releaseDate &&
                isValidUrl(form.thumbnail) &&
                isValidUrl(form.videoLink)
              )
            }
            color="error"
            variant="contained"
            onClick={postVideo}
          >
            Upload
          </Button>
          <Button sx={{ color: "#ffff" }} onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default Upload;
